import PropTypes from 'prop-types';
// @mui
import { Card, Skeleton, Stack } from '@mui/material';

// ----------------------------------------------------------------------

SkeletonCourseCard.propTypes = {
  mediaHeight: PropTypes.number,
  textLines: PropTypes.number,
  actions: PropTypes.number,
};

/**
 * Espelha a estrutura do card de curso (capa + título + apoio + ações),
 * para que o carregamento tenha a mesma silhueta do conteúdo final.
 */
export default function SkeletonCourseCard({
  mediaHeight = 240,
  textLines = 2,
  actions = 1,
  ...other
}) {
  return (
    <Card sx={{ height: 1, width: 1, display: 'flex', flexDirection: 'column' }} {...other}>
      <Skeleton variant="rectangular" sx={{ width: 1, height: mediaHeight, flexShrink: 0 }} />

      <Stack spacing={1} sx={{ p: 2, mt: 'auto' }}>
        <Skeleton variant="text" sx={{ width: 0.7, height: 28 }} />

        {[...Array(Math.max(textLines - 1, 0))].map((_, index) => (
          <Skeleton key={index} variant="text" sx={{ width: 0.45 }} />
        ))}

        {[...Array(actions)].map((_, index) => (
          <Skeleton key={index} variant="rounded" sx={{ width: 1, height: 36, mt: 0.5 }} />
        ))}
      </Stack>
    </Card>
  );
}
